
shadow.loader.set_load_start('authed-app');